import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Paper,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { auth, db } from "../Config/firebase";
import { aplicarTenantAtual, consultaTenantAtual } from "../Utils/tenant";

const COLLECTION = "tblControleManutencaoEquipamentos";

const MANUTENCAO_BETONEIRA = "Limpeza, verificação de correias, polias e engrenagens, fazer lubrificação com graxa caso necessário, verificar funcionamento do motor";
const MANUTENCAO_PERFURATRIZ = "Verificar desgaste da broca, conferir cabo de alimentação e plugues, testar interruptores e botões de acionamento";

const EQUIPAMENTOS_PADRAO = [
  { equipamento: "Betoneira", identificacao: "Menegote - 150L", formaManutencao: MANUTENCAO_BETONEIRA, periodicidade: "Antes do uso", ultimaManutencao: "27/9", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Betoneira", identificacao: "CSM 02 - 150L", formaManutencao: MANUTENCAO_BETONEIRA, periodicidade: "Antes do uso", ultimaManutencao: "-", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Betoneira", identificacao: "Menegote - 400L", formaManutencao: MANUTENCAO_BETONEIRA, periodicidade: "Antes do uso", ultimaManutencao: "26/9", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Furadeira", identificacao: "", formaManutencao: "", periodicidade: "", ultimaManutencao: "", proximaManutencao: "", status: "Em uso" },
  { equipamento: "Perfuratriz", identificacao: "BOSH", formaManutencao: MANUTENCAO_PERFURATRIZ, periodicidade: "Antes do uso", ultimaManutencao: "Após o uso", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Perfuratriz", identificacao: "HILT", formaManutencao: MANUTENCAO_PERFURATRIZ, periodicidade: "Antes do uso", ultimaManutencao: "Após o uso", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Perfuratriz", identificacao: "TIROLYT", formaManutencao: MANUTENCAO_PERFURATRIZ, periodicidade: "Antes do uso", ultimaManutencao: "Após o uso", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Perfuratriz", identificacao: "VOLTH", formaManutencao: MANUTENCAO_PERFURATRIZ, periodicidade: "Antes do uso", ultimaManutencao: "Após o uso", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Misturador de argamassa", identificacao: "-", formaManutencao: "Limpeza do cuba, inspeção dos rolamentos e desgaste da mesma, verificar desgaste das pás misturadoras, verificar botões de acionamento", periodicidade: "Antes do uso", ultimaManutencao: "Após o uso", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Forma para corpos de prova", identificacao: "-", formaManutencao: "Limpeza, usar desmoldante para evitar aderência, conferir integridade da forma", periodicidade: "Antes do uso", ultimaManutencao: "Após o uso", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Utensílios e ferramentas de ensaio", identificacao: "-", formaManutencao: "Inspeção e limpeza", periodicidade: "Antes do uso", ultimaManutencao: "Após o uso", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Carrinho de mão", identificacao: "-", formaManutencao: "Verificar se pneu está cheio, limpeza e inspeção em geral", periodicidade: "Antes do uso", ultimaManutencao: "Após o uso", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Retífica de corpos de prova", identificacao: "-", formaManutencao: "Verificar aquecimento ou ruídos anormais, conferir cabos, plugues e chave de acionamento, inspecionar desgaste no rebolo, verificar fluxo de água no sistema de refrigeração", periodicidade: "Antes do uso", ultimaManutencao: "Após o uso", proximaManutencao: "Antes do uso", status: "Em uso" },
  { equipamento: "Policorte", identificacao: "-", formaManutencao: "Verificar aquecimento ou ruídos anormais, conferir cabos, verificar se o disco está gasto ou danificado, verificar protetor do disco", periodicidade: "Antes do uso", ultimaManutencao: "Após o uso", proximaManutencao: "Antes do uso", status: "Em uso" },
];

const equipamentoVazio = () => ({
  equipamento: "",
  identificacao: "",
  formaManutencao: "",
  periodicidade: "",
  ultimaManutencao: "",
  proximaManutencao: "",
  status: "Em uso",
});

function criarControleInicial() {
  return {
    codigo: "RQ 4.4",
    aprovadoEm: "2025-08-10",
    equipamentos: EQUIPAMENTOS_PADRAO.map((item) => ({ ...item })),
  };
}

function formatarData(data) {
  if (!data) return "-";
  const [ano, mes, dia] = String(data).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : data;
}

function corStatus(status) {
  if (status === "Em manutenção") return "#ed6c02";
  if (status === "Fora de uso") return "#d32f2f";
  return "#078568";
}

function ControleVisual({ item, onEditar, onAdicionarEquipamento }) {
  const equipamentos = Array.isArray(item.equipamentos) ? item.equipamentos : [];
  const cabecalho = { backgroundColor: "#687387", color: "white", fontWeight: 800, border: "1px solid #94a3b8" };
  const celula = { border: "1px solid #94a3b8", whiteSpace: "pre-line" };

  return (
    <Box sx={{ mt: 3 }}>
      <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} spacing={1} sx={{ mb: 1.5 }}>
        <Typography variant="body2" fontWeight={700}>
          {item.codigo || "RQ 4.4"} — Aprovado em {formatarData(item.aprovadoEm)}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Button size="small" variant="outlined" startIcon={<EditIcon />} onClick={() => onEditar(item)}>Editar controle</Button>
          <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => onAdicionarEquipamento(item)}>Novo equipamento</Button>
          <HistoricoCadastro colecao={COLLECTION} documentoId={item.id} registro={item} />
        </Stack>
      </Stack>

      <Paper variant="outlined" sx={{ overflowX: "auto" }}>
        <Table size="small" sx={{ minWidth: 1250, tableLayout: "fixed" }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ ...cabecalho, width: "14%" }}>Equipamento</TableCell>
              <TableCell align="center" sx={{ ...cabecalho, width: "13%" }}>Identificação</TableCell>
              <TableCell align="center" sx={{ ...cabecalho, width: "29%" }}>Forma de manutenção</TableCell>
              <TableCell align="center" sx={{ ...cabecalho, width: "11%" }}>Periodicidade</TableCell>
              <TableCell align="center" sx={{ ...cabecalho, width: "11%" }}>Data da Última Manutenção</TableCell>
              <TableCell align="center" sx={{ ...cabecalho, width: "11%" }}>Data Próxima Manutenção</TableCell>
              <TableCell align="center" sx={{ ...cabecalho, width: "11%" }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {equipamentos.map((equipamento, indice) => (
              <TableRow key={`${equipamento.equipamento}-${equipamento.identificacao}-${indice}`}>
                <TableCell align="center" sx={{ ...celula, fontWeight: 700 }}>{equipamento.equipamento || "-"}</TableCell>
                <TableCell align="center" sx={{ ...celula, fontWeight: 700 }}>{equipamento.identificacao || "-"}</TableCell>
                <TableCell align="center" sx={celula}>{equipamento.formaManutencao || "-"}</TableCell>
                <TableCell align="center" sx={celula}>{equipamento.periodicidade || "-"}</TableCell>
                <TableCell align="center" sx={celula}>{equipamento.ultimaManutencao || "-"}</TableCell>
                <TableCell align="center" sx={celula}>{equipamento.proximaManutencao || "-"}</TableCell>
                <TableCell align="center" sx={celula}>
                  <Box sx={{ px: 1.25, py: 0.3, borderRadius: 5, color: "white", bgcolor: corStatus(equipamento.status), fontWeight: 700, fontSize: "0.75rem" }}>
                    {equipamento.status || "Em uso"}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}

export default function CadastroControleManutencaoEquipamentos() {
  const [controles, setControles] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [dialogAberto, setDialogAberto] = useState(false);
  const [controleEditando, setControleEditando] = useState(null);
  const [controle, setControle] = useState(criarControleInicial());
  const [notificacao, setNotificacao] = useState({ aberta: false, mensagem: "", tipo: "success" });
  const cadastrandoPadraoRef = useRef(false);

  async function carregarControles() {
    setCarregando(true);
    try {
      const snapshot = await getDocs(consultaTenantAtual(query(collection(db, COLLECTION), orderBy("criadoEm", "desc"))));
      setControles(snapshot.docs.map((documento) => ({ id: documento.id, ...documento.data() })));
    } catch (error) {
      console.error("Erro ao carregar o Controle de Manutenção de Equipamentos:", error);
      setNotificacao({ aberta: true, mensagem: "Não foi possível carregar o Controle de Manutenção de Equipamentos.", tipo: "error" });
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    carregarControles();
  }, []);

  function dadosParaEdicao(item, adicionarEquipamento = false) {
    return {
      codigo: item.codigo || "RQ 4.4",
      aprovadoEm: item.aprovadoEm || "",
      equipamentos: [
        ...(Array.isArray(item.equipamentos) ? item.equipamentos.map((equipamento) => ({ ...equipamento })) : []),
        ...(adicionarEquipamento ? [equipamentoVazio()] : []),
      ],
    };
  }

  function abrirEdicao(item) {
    setControleEditando(item);
    setControle(dadosParaEdicao(item));
    setDialogAberto(true);
  }

  function abrirNovoEquipamento(item) {
    setControleEditando(item);
    setControle(dadosParaEdicao(item, true));
    setDialogAberto(true);
  }

  async function cadastrarControlePadrao() {
    if (controles.length > 0 || cadastrandoPadraoRef.current) return;
    cadastrandoPadraoRef.current = true;
    setSalvando(true);
    const controleInicial = criarControleInicial();
    try {
      const documentoCriado = await addDoc(collection(db, COLLECTION), aplicarTenantAtual({
        ...controleInicial,
        criadoEm: serverTimestamp(),
        criadoPor: auth.currentUser?.uid || null,
        atualizadoEm: serverTimestamp(),
        atualizadoPor: auth.currentUser?.uid || null,
      }));
      setControles([{ id: documentoCriado.id, ...controleInicial }]);
      setNotificacao({ aberta: true, mensagem: "Controle padrão cadastrado com sucesso.", tipo: "success" });
    } catch (error) {
      console.error("Erro ao cadastrar o controle padrão:", error);
      setNotificacao({ aberta: true, mensagem: "Não foi possível cadastrar o controle padrão.", tipo: "error" });
    } finally {
      cadastrandoPadraoRef.current = false;
      setSalvando(false);
    }
  }

  function atualizarCampo(campo, valor) {
    setControle((atual) => ({ ...atual, [campo]: valor }));
  }

  function atualizarEquipamento(indice, campo, valor) {
    setControle((atual) => ({
      ...atual,
      equipamentos: atual.equipamentos.map((item, index) => index === indice ? { ...item, [campo]: valor } : item),
    }));
  }

  function adicionarEquipamento() {
    setControle((atual) => ({ ...atual, equipamentos: [...atual.equipamentos, equipamentoVazio()] }));
  }

  function removerEquipamento(indice) {
    setControle((atual) => ({ ...atual, equipamentos: atual.equipamentos.filter((_, index) => index !== indice) }));
  }

  async function salvar() {
    if (!controle.codigo.trim()) {
      setNotificacao({ aberta: true, mensagem: "Informe o código do controle.", tipo: "warning" });
      return;
    }
    if (controle.equipamentos.some((item) => !item.equipamento.trim())) {
      setNotificacao({ aberta: true, mensagem: "Informe o equipamento em todas as linhas.", tipo: "warning" });
      return;
    }

    setSalvando(true);
    try {
      await updateDoc(doc(db, COLLECTION, controleEditando.id), {
        codigo: controle.codigo.trim(),
        aprovadoEm: controle.aprovadoEm,
        equipamentos: controle.equipamentos.map((item) => ({
          equipamento: item.equipamento.trim(),
          identificacao: item.identificacao.trim(),
          formaManutencao: item.formaManutencao.trim(),
          periodicidade: item.periodicidade.trim(),
          ultimaManutencao: item.ultimaManutencao.trim(),
          proximaManutencao: item.proximaManutencao.trim(),
          status: item.status || "Em uso",
        })),
        atualizadoEm: serverTimestamp(),
        atualizadoPor: auth.currentUser?.uid || null,
      });
      setDialogAberto(false);
      setNotificacao({ aberta: true, mensagem: "Controle de Manutenção atualizado com sucesso.", tipo: "success" });
      await carregarControles();
    } catch (error) {
      console.error("Erro ao salvar o Controle de Manutenção de Equipamentos:", error);
      setNotificacao({ aberta: true, mensagem: "Não foi possível salvar o Controle de Manutenção de Equipamentos.", tipo: "error" });
    } finally {
      setSalvando(false);
    }
  }

  return (
    <>
      <Navbar />
      <Box sx={{ p: { xs: 2, md: 4 }, mt: 6 }}>
        <Paper className="cabecalho-lista-cadastro" elevation={0} sx={{ mb: 2 }}>
          <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" spacing={2} alignItems={{ md: "center" }}>
            <Box>
              <Typography variant="h5" fontWeight={700}>Controle de Manutenção de Equipamentos</Typography>
              <Typography variant="body2" color="text.secondary">RQ 4.4 — Sistema de Gestão da Qualidade</Typography>
            </Box>
            {controles.length === 0 && !carregando && <Button variant="outlined" onClick={cadastrarControlePadrao} disabled={salvando}>Cadastrar controle padrão</Button>}
          </Stack>

          {carregando && <Box sx={{ p: 4, textAlign: "center" }}><CircularProgress size={24} /></Box>}
          {!carregando && controles.length === 0 && <Box sx={{ p: 4, textAlign: "center" }}>Nenhum Controle de Manutenção de Equipamentos cadastrado.</Box>}
          {!carregando && controles.map((item) => <ControleVisual key={item.id} item={item} onEditar={abrirEdicao} onAdicionarEquipamento={abrirNovoEquipamento} />)}
        </Paper>
      </Box>

      <Dialog open={dialogAberto} onClose={() => !salvando && setDialogAberto(false)} fullWidth maxWidth="xl">
        <DialogTitle>Editar Controle de Manutenção de Equipamentos</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <TextField label="Código" value={controle.codigo} onChange={(event) => atualizarCampo("codigo", event.target.value)} fullWidth required />
              <TextField label="Aprovado em" type="date" value={controle.aprovadoEm} onChange={(event) => atualizarCampo("aprovadoEm", event.target.value)} InputLabelProps={{ shrink: true }} fullWidth />
            </Stack>

            <Paper variant="outlined" sx={{ overflowX: "auto" }}>
              <Table size="small" sx={{ minWidth: 1500 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Equipamento</TableCell>
                    <TableCell>Identificação</TableCell>
                    <TableCell>Forma de manutenção</TableCell>
                    <TableCell>Periodicidade</TableCell>
                    <TableCell>Última manutenção</TableCell>
                    <TableCell>Próxima manutenção</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {controle.equipamentos.map((item, indice) => (
                    <TableRow key={indice}>
                      <TableCell sx={{ minWidth: 180 }}><TextField value={item.equipamento} onChange={(event) => atualizarEquipamento(indice, "equipamento", event.target.value)} size="small" fullWidth required /></TableCell>
                      <TableCell sx={{ minWidth: 170 }}><TextField value={item.identificacao} onChange={(event) => atualizarEquipamento(indice, "identificacao", event.target.value)} size="small" fullWidth /></TableCell>
                      <TableCell sx={{ minWidth: 360 }}><TextField value={item.formaManutencao} onChange={(event) => atualizarEquipamento(indice, "formaManutencao", event.target.value)} size="small" multiline minRows={3} fullWidth /></TableCell>
                      <TableCell sx={{ minWidth: 150 }}><TextField value={item.periodicidade} onChange={(event) => atualizarEquipamento(indice, "periodicidade", event.target.value)} size="small" fullWidth /></TableCell>
                      <TableCell sx={{ minWidth: 160 }}><TextField value={item.ultimaManutencao} onChange={(event) => atualizarEquipamento(indice, "ultimaManutencao", event.target.value)} size="small" fullWidth /></TableCell>
                      <TableCell sx={{ minWidth: 160 }}><TextField value={item.proximaManutencao} onChange={(event) => atualizarEquipamento(indice, "proximaManutencao", event.target.value)} size="small" fullWidth /></TableCell>
                      <TableCell sx={{ minWidth: 160 }}>
                        <TextField select value={item.status || "Em uso"} onChange={(event) => atualizarEquipamento(indice, "status", event.target.value)} size="small" fullWidth>
                          <MenuItem value="Em uso">Em uso</MenuItem>
                          <MenuItem value="Em manutenção">Em manutenção</MenuItem>
                          <MenuItem value="Fora de uso">Fora de uso</MenuItem>
                        </TextField>
                      </TableCell>
                      <TableCell><Tooltip title="Remover equipamento"><IconButton size="small" color="error" onClick={() => removerEquipamento(indice)}><DeleteOutlineIcon /></IconButton></Tooltip></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
            <Button startIcon={<AddIcon />} onClick={adicionarEquipamento} sx={{ alignSelf: "flex-start" }}>Adicionar equipamento</Button>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogAberto(false)} disabled={salvando}>Cancelar</Button>
          <Button variant="contained" onClick={salvar} disabled={salvando}>{salvando ? "Salvando..." : "Salvar"}</Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={notificacao.aberta} autoHideDuration={5000} onClose={() => setNotificacao((atual) => ({ ...atual, aberta: false }))}>
        <Alert severity={notificacao.tipo} onClose={() => setNotificacao((atual) => ({ ...atual, aberta: false }))}>{notificacao.mensagem}</Alert>
      </Snackbar>
    </>
  );
}
